import type { BasicCustomerFragment, CompleteStoreFragment } from '@drycut/graphql';

import { ActionButtons, Button, InfoButton, Para, Stack } from '@drycut/ui-components';
import { useState } from 'react';
import { type SubmitHandler, useFormContext } from 'react-hook-form';

import type { BookFormValues } from '../..';

import { ControlledPhoneField } from '../../../ControlledPhoneField';
import { useBookingContext } from '../../BookingProvider';
import StepContainer from '../../StepContainer';
import CancelButton from '../CancelButton';
import StepWaitingTime from '../StepWaitingTime';

type Props = {
  onCancel: () => void;
  onNext: () => void;
  store: CompleteStoreFragment;
};

export function PhoneStep({ store, onNext, onCancel }: Props): React.ReactElement {
  const { setValue, handleSubmit } = useFormContext<BookFormValues>();
  const [validating, setValidating] = useState<boolean>(false);
  const { manual } = useBookingContext();

  const onSubmit: SubmitHandler<BookFormValues> = async () => {
    onNext();
  };

  const handleExistingCustomer = (validated: BasicCustomerFragment) => {
    const { phoneNumber, name } = validated;

    setValue('phone', phoneNumber);
    setValue('name', name);
    setValue('existingCustomer', !!name);
  };

  return (
    <StepContainer onSubmit={handleSubmit(onSubmit)} store={store}>
      <StepWaitingTime store={store} />

      <Stack gap={2} className="w-72">
        <ControlledPhoneField
          setValidating={setValidating}
          onSucessfulValidation={handleExistingCustomer}
          autoComplete={manual ? 'off' : 'telephone'}
        />

        <Para size="xs" className="mt-2">
          Zur Bestätigung senden wir Dir eine SMS mit Deiner persönlichen Wartezeit.
        </Para>

        <Stack gap={2} direction="row">
          <Para size="xs">
            Um ein gutes Resultat zu garantiere, bitte beachte unsere "clean hair policy".
          </Para>

          <InfoButton
            title="Clean hair policy"
            text="Haare sollten keine oder wenig Produkte (Gel, Pomade, etc.) enthalten und in den vergangenen 24 Stunden gewaschen worden sein."
          />
        </Stack>
      </Stack>

      <ActionButtons>
        <Button type="submit" loading={validating}>
          Weiter
        </Button>
        <CancelButton onCancel={onCancel} />
      </ActionButtons>
    </StepContainer>
  );
}
